import * as yup from 'yup'

const assetSchema = yup.object().shape({
  account: yup.string().nullable().optional(),
  amount: yup.string().nullable().optional(),
})

export const balanceSheetSinglePeriodXlsxFileDataSchema = yup.object().shape({
  title: yup.string().nullable().optional(),
  description: yup.string().nullable().optional(),
  periodEnd: yup.string().nullable().optional(),
  currentAssets: yup.array().of(assetSchema).required(),
  fixedAssets: yup.array().of(assetSchema).required(),
  otherAssets: yup.array().of(assetSchema).required(),
  currentLiabilities: yup.array().of(assetSchema).required(),
  otherLiabilities: yup.array().of(assetSchema).required(),
  equities: yup.array().of(assetSchema).required(),
})

export type BalanceSheetSinglePeriodXlsxFileData = yup.InferType<
  typeof balanceSheetSinglePeriodXlsxFileDataSchema
>

export const balanceSheetSinglePeriodXlsxFileMappings = {
  title: 'a1b2c3d4-e5f6-4a7b-8c9d-0e1f2a3b4c5d',
  description: 'b2c3d4e5-f6a7-4b8c-9d0e-1f2a3b4c5d6e',
  periodEnd: 'c3d4e5f6-a7b8-4c9d-0e1f-2a3b4c5d6e7f',
  currentAssets: [
    {
      account: 'd4e5f6a7-b8c9-4d0e-1f2a-3b4c5d6e7f8a',
      amount: 'e5f6a7b8-c9d0-4e1f-2a3b-4c5d6e7f8a9b',
    },
  ],
  fixedAssets: [
    {
      account: 'f6a7b8c9-d0e1-4f2a-3b4c-5d6e7f8a9b0c',
      amount: 'a7b8c9d0-e1f2-4a3b-4c5d-6e7f8a9b0c1d',
    },
  ],
  otherAssets: [
    {
      account: 'b8c9d0e1-f2a3-4b4c-5d6e-7f8a9b0c1d2e',
      amount: 'c9d0e1f2-a3b4-4c5d-6e7f-8a9b0c1d2e3f',
    },
  ],
  currentLiabilities: [
    {
      account: 'd0e1f2a3-b4c5-4d6e-7f8a-9b0c1d2e3f4a',
      amount: 'e1f2a3b4-c5d6-4e7f-8a9b-0c1d2e3f4a5b',
    },
  ],
  otherLiabilities: [
    {
      account: 'f2a3b4c5-d6e7-4f8a-9b0c-1d2e3f4a5b6c',
      amount: 'a3b4c5d6-e7f8-4a9b-0c1d-2e3f4a5b6c7d',
    },
  ],
  equities: [
    {
      account: 'b4c5d6e7-f8a9-4b0c-1d2e-3f4a5b6c7d8e',
      amount: 'c5d6e7f8-a9b0-4c1d-2e3f-4a5b6c7d8e9f',
    },
  ],
}
